export enum NeoFacetPrefixApiEnum {
    hashtag = '#',
    handle = '@',
    words = ''
}
